export const defaultBrandIconName = "ICON_DEFAULT";

export const brandIconOptions: { iconName: string; label: string }[] = [
  { iconName: defaultBrandIconName, label: "Label" },
  { iconName: "ICON_LEGAL", label: "Legal" },
  { iconName: "ICON_NOTICE", label: "Capital Call Notice" },
  { iconName: "ICON_DISTRIBUTION_NOTICE", label: "Distribution Notice" },
  { iconName: "ICON_MONEY", label: "Cash Distribution" },
  { iconName: "ICON_REPORT", label: "Financial Statement" },
  { iconName: "ICON_TAX", label: "Tax" },
  { iconName: "ICON_PCAPS", label: "Capital Account Statement" },
  { iconName: "ICON_QUARTERLY_CAPITAL_STATEMENTS", label: "Quarterly Statements" },
  { iconName: "ICON_QUARTERLY_NEWS", label: "Quarterly Newsletter" },
  { iconName: "ICON_ANNUAL_QUARTERLY_REPORTS", label: "Annual & Quarterly Reports" },
  { iconName: "ICON_ANNUAL_MEETING_NOTICES", label: "Meeting Notices" },
  { iconName: "ICON_CALENDAR", label: "Annual Meetings" },
  { iconName: "ICON_ACQUISITION", label: "Acquisition" },
  { iconName: "ICON_LP", label: "Limited Partner" },
  { iconName: "ICON_BOOKS", label: "Correspondence" },
  { iconName: "ICON_GENERAL", label: "General" },
  { iconName: "ICON_OTHER", label: "Other" },
];
